import * as React from 'react';
import UserDashboard from '../Dashboard/UserDashboard';

export default function Dashboard(): React.ReactElement {
  return <UserDashboard />;
}
